// extracted by mini-css-extract-plugin
export var standaloneTable = "_k-0";
export var standaloneTableWithBodyFill = "_k-1";
export var withExtraHeader = "_k-2";